__webpack_require__.p = "https://bmidxbbulgariaplpreprod.netlify.app/";